module.exports = __webpack_public_path__ + "static/media/icon-arrow-right.e568a48f.svg";